export default __webpack_public_path__ + "static/media/flyjs.fce2b1a4.svg";